import { render, staticRenderFns } from "./AppTreinosDia.vue?vue&type=template&id=483a1c57&"
import script from "./AppTreinosDia.vue?vue&type=script&lang=js&"
export * from "./AppTreinosDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports